module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("modal-container" + (_vm.isActive ? ' is-active' : '') + (_vm.isLarge ? ' is-large' : ''))
  }, [_c('div', {
    staticClass: "modal__overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('h2', {
    staticClass: "modal__header"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('div', {
    staticClass: "modal__content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal__buttons"
  }, [_vm._t("modalButtons", null, {
    "close": _vm.close
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64e9468e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 1054
// module chunks = 1